<!-- Desktop stepper -->
<div class="container steps-progress-bar d-none d-md-block">
	<div class="steps-track">
		@for (step of steps; track step.route; let i = $index) {
			<div
				class="step-item"
				[class.completed]="isCompleted(i)"
				[class.current]="isCurrent(i)"
				[class.clickable]="canNavigate(i)"
				(click)="navigate(i)"
				(keydown.enter)="navigate(i)"
				[attr.role]="canNavigate(i) ? 'button' : null"
				[attr.tabindex]="canNavigate(i) ? 0 : null">
				<div class="step-connector" [class.filled]="isCompleted(i)"></div>
				<div class="step-circle">
					@if (isCompleted(i)) {
						<i class="bi bi-check-lg"></i>
					} @else {
						<span>{{ i + 1 }}</span>
					}
				</div>
				<span class="step-label">{{ step.label | translate }}</span>
			</div>
		}
	</div>
</div>

<!-- Mobile compact bar -->
<div class="steps-progress-mobile d-md-none">
	<div class="container d-flex align-items-center gap-3 py-2">
		<div class="steps-mobile-dots d-flex align-items-center gap-1">
			@for (step of steps; track step.route; let i = $index) {
				<div class="mobile-dot" [class.completed]="isCompleted(i)" [class.current]="isCurrent(i)"></div>
			}
		</div>
		<div class="d-flex flex-column">
			<span class="steps-mobile-count">{{ 'passoNDiM' | translate: { n: activeIndex + 1, tot: steps.length } }}</span>
			<span class="steps-mobile-label">{{ currentLabel | translate }}</span>
		</div>
	</div>
	<div class="steps-mobile-fill-track">
		<div class="steps-mobile-fill" [style.width.%]="progressPercent"></div>
	</div>
</div>
